import * as types from './mutation-types';

export const showUnlockLevelPopup = async ({commit}, id) => {
    commit(types.SHOW_UNLOCK_LEVEL_POPUP, id);
};

export const hideUnlockLevelPopup = async ({commit}, id) => {
    commit(types.HIDE_UNLOCK_LEVEL_POPUP);
};
export default {
    showUnlockLevelPopup,
    hideUnlockLevelPopup,
};



// WEBPACK FOOTER //
// ./src/store/modules/popup/actions.js